import React, {Component} from 'react';
import type {SubscriptionPlan} from "amn/model/account/Subscription";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {NavLink} from "react-router-dom";
import PortalPaths from "../../../../common/routes/PortalPaths";
import AmnAuditorTrialWizardMobile from "./AmnAuditorTrialWizardMobile";
import Hidden from "@material-ui/core/Hidden";
import AmnAuditorTrialWizard from "./AmnAuditorTrialWizard";

type Props = {
  plan: SubscriptionPlan;
  canStartTrial: boolean;
};

type State = {};


class AmnAuditorStartTrialContent extends Component<Props, State> {

  constructor(props) {
    super(props);
    this.canStartTrial = props.canStartTrial;
  }

  render() {
    return (
      <>
        {this.canStartTrial ?
          <>
            <Hidden mdUp>
              <AmnAuditorTrialWizardMobile plan={this.props.plan}/>
            </Hidden>
            <Hidden smDown>
              <AmnAuditorTrialWizard plan={this.props.plan}/>
            </Hidden>
          </> :
          this.renderWarningMessage()
        }
      </>
    );
  }

  renderWarningMessage() {
    return (
      <Box mt={8} pt={8} pb={8}>

        <Box mt={8} display="flex" justifyContent="center">
          <svg height={80} width={80} viewBox="0 0 226 226">
            <g fill="#e3e6ed">
              <path
                d="M26.21953,22.6c-6.93067,0 -12.65953,5.72886 -12.65953,12.65953v23.50047v4.52v135.6c0,2.49956 2.02496,4.52 4.52,4.52h113.45906c-1.32888,-2.88828 -2.39553,-5.90764 -3.20461,-9.04h-105.73445v-131.08h180.8v68.25906c3.19564,1.46448 6.215,3.23639 9.04,5.27039v-78.04945v-23.50047c0,-6.93067 -5.72886,-12.65953 -12.65953,-12.65953zM26.21953,31.64h173.56094c2.10933,0 3.61953,1.5102 3.61953,3.61953v18.98047h-180.8v-18.98047c0,-2.10933 1.5102,-3.61953 3.61953,-3.61953zM45.2,90.4c-2.49633,0 -4.52,2.02367 -4.52,4.52c0,2.49633 2.02367,4.52 4.52,4.52c2.49633,0 4.52,-2.02367 4.52,-4.52c0,-2.49633 -2.02367,-4.52 -4.52,-4.52zM67.8,90.4v9.04h113v-9.04zM45.2,122.04c-2.49633,0 -4.52,2.02367 -4.52,4.52c0,2.49633 2.02367,4.52 4.52,4.52c2.49633,0 4.52,-2.02367 4.52,-4.52c0,-2.49633 -2.02367,-4.52 -4.52,-4.52zM67.8,122.04v9.04h81.36v-9.04zM180.8,135.6c-24.90973,0 -45.2,20.29027 -45.2,45.2c0,24.90973 20.29027,45.2 45.2,45.2c24.90973,0 45.2,-20.29027 45.2,-45.2c0,-24.90973 -20.29027,-45.2 -45.2,-45.2zM180.8,144.64c20.02416,0 36.16,16.13584 36.16,36.16c0,20.02416 -16.13584,36.16 -36.16,36.16c-20.02416,0 -36.16,-16.13584 -36.16,-36.16c0,-20.02416 16.13584,-36.16 36.16,-36.16zM45.2,153.68c-2.49633,0 -4.52,2.02367 -4.52,4.52c0,2.49633 2.02367,4.52 4.52,4.52c2.49633,0 4.52,-2.02367 4.52,-4.52c0,-2.49633 -2.02367,-4.52 -4.52,-4.52zM67.8,153.68v9.04h58.76v-9.04zM164.93586,160.41586c-1.83929,0.00048 -3.4949,1.11534 -4.18702,2.81944c-0.69211,1.70411 -0.28271,3.65765 1.03538,4.94048l12.62422,12.62422l-12.62422,12.62422c-1.18081,1.13369 -1.65647,2.81717 -1.24354,4.40116c0.41293,1.584 1.64993,2.821 3.23393,3.23393c1.584,0.41293 3.26747,-0.06273 4.40116,-1.24354l12.62422,-12.62422l12.62422,12.62422c1.13369,1.18081 2.81717,1.65647 4.40116,1.24354c1.584,-0.41293 2.821,-1.64993 3.23393,-3.23393c0.41293,-1.584 -0.06273,-3.26747 -1.24354,-4.40116l-12.62422,-12.62422l12.62422,-12.62422c1.33684,-1.29946 1.73879,-3.28634 1.01219,-5.00325c-0.72661,-1.71691 -2.43272,-2.81163 -4.29625,-2.75668c-1.17429,0.03499 -2.28883,0.52577 -3.1075,1.36836l-12.62422,12.62422l-12.62422,-12.62422c-0.85099,-0.87477 -2.01951,-1.36829 -3.23992,-1.36836z"/>
            </g>
          </svg>
        </Box>
        <Box mt={2} display="flex" justifyContent="center">
          Vous avez déjà une licence d'essai
        </Box>
        <Box mt={2} display="flex" justifyContent="center">
          <Button variant="contained"
                  color="primary"
                  component={NavLink}
                  to={PortalPaths.accountLicensesUrl()}>
            Ouvrir la liste des licences
          </Button>
        </Box>
      </Box>
    );
  }

}


export default AmnAuditorStartTrialContent;

